import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StudentprofilemainComponent } from '../../eduman/student/studentprofilemain/studentprofilemain.component';


const routes: Routes = [
  {
    path: 'profile',
    component: StudentprofilemainComponent,
    data: {
      title: 'Mi perfil',
      breadcrumb: 'Perfil',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingRoutingModule { }
